// extracted by mini-css-extract-plugin
export default {"video":"lsf-video","video__controls":"lsf-video__controls","video__play":"lsf-video__play","video__frame":"lsf-video__frame","video__progress":"lsf-video__progress","video__current-time":"lsf-video__current-time"};
    if(module.hot) {
      // 1637785525831
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  